import { Component } from '@angular/core';
import { Toast } from 'source/app/controls/components/toast/toast';
import { ControlsModule } from 'source/app/controls/controls-module';

@Component({
    templateUrl: './message-toast.html',
    styles: [`
    :host {
      pointer-events: none;
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0px;
      z-index: 1000;
    }
  `]
})
export class MessageToast extends Toast {
    static Show() {
        var dialog = ControlsModule.toast.Show(MessageToast);
    }

    constructor() {
        super();
    }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/toast/message-toast.ts